import { TFunction } from "i18next";
import * as z from "zod";

export const zoneFormSchema = z.object({
  name: z.string(),
  description: z.string().nullable().optional(),
  parent_id: z.string().nullable(),
});

export type ZoneFormSchema = z.infer<typeof zoneFormSchema>;

export function buildZoneFormSchema(
  zones: { id: string; name: string; parent_id?: string | null }[],
  t: TFunction,
  currentZoneId?: string,
) {
  const isCreate = currentZoneId === undefined;

  // Create requires parent_id, edit has disabled it but needs to save the top-level zone
  const schema = isCreate
    ? zoneFormSchema.extend({
        parent_id: z.string({ error: t("error_message_zone_parent_zone") }),
      })
    : zoneFormSchema;

  // Ensure unique sibling names
  return schema.superRefine((value, ctx) => {
    const trimmedName = value.name?.trim().toLowerCase();

    if (!trimmedName) return;

    const duplicate = zones.some(
      (zone) =>
        zone.id !== currentZoneId &&
        zone.name.trim().toLowerCase() === trimmedName &&
        (zone.parent_id ?? null) === (value.parent_id ?? null),
    );

    if (duplicate) {
      ctx.addIssue({
        code: "custom",
        path: ["name"],
        message: t("zone_with_name_already_exists_in_parent"),
      });
    }
  });
}
